import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { useTheme, buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import LoadingIndicator from 'Components/UI/LoadingIndicator';
import IconButton from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/IconButton';
import SendIcon from '@material-ui/icons/Send';
import { noop } from 'Helpers/PropTypes';

const useStyles = buildUseStyles('SendButton', () => ({
  root: {
    boxSizing: 'content-box',
    height: 20,
    width: 20,
  },
}));

const SendButton = ({
  className,
  onClick,
  disabled,
  sending,
  dataTestAttributes,
}) => {
  const theme = useTheme();
  const classes = useStyles(theme);

  if (sending) {
    return (
      <LoadingIndicator
        className={classNames(className, classes.root)}
        size={20}
      />
    );
  }

  return (
    <IconButton
      className={classNames(className, classes.root)}
      onClick={() => onClick()}
      variant={'contained'}
      color={'primary'}
      title={'Send Message'}
      size={'small'}
      icon={SendIcon}
      disabled={disabled}
      {...dataTestAttributes}
    />
  );
};

SendButton.defaultProps = {
  className: '',
  onClick: noop,
  sending: false,
  disabled: false,
  dataTestAttributes: {},
};

SendButton.propTypes = {
  className: PropTypes.string,
  onClick: PropTypes.func,
  sending: PropTypes.bool,
  disabled: PropTypes.bool,
  dataTestAttributes: PropTypes.object,
};

export { SendButton };
